// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { Shift_abstract } from './../abstract/SagaBase/Shift_abstract';
export class Shift extends Shift_abstract {}
